import axios from "axios";

const api = axios.create({
  baseURL: process.env.NODE_ENV === 'production'
    ? "https://api.djparafestas.com.br/api/v2/"
    : (process.env.REACT_APP_API_URL || "http://localhost:8000/api/v2/"),
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;